module.exports = __webpack_public_path__ + "img/ArrarLOGO.fc16f774.png";